import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Modal from './../Modal/Modal'
import './Confirm.scss'

interface IConfirmProps extends WithTranslation {
  onClose: (confirm: boolean) => void
  visible: boolean
  title: string
  message?: string
}

class Confirm extends Component<IConfirmProps> {
  render() {
    const { title, message, t, visible } = this.props

    return (
      <Modal
        title={title}
        onClose={() => {
          this.onClose(false)
        }}
        visible={visible}
        hideCloseBtn={true}
      >
        <i className="confirm-icon icon-info" /> <span className="confirmTxt">{message}</span>
        <div className="modal-bottom">
          <button
            onClick={() => {
              this.onClose(true)
            }}
          >
            {t('OK')}
          </button>
          <button
            onClick={() => {
              this.onClose(false)
            }}
          >
            {t('CANCEL')}
          </button>
        </div>
      </Modal>
    )
  }

  private onClose(confirm: boolean) {
    this.props.onClose(confirm)
  }
}
// eslint-disable-next-line react-refresh/only-export-components
export default withTranslation('common')(Confirm)
